<template>
    <div class="p-4">
        <div class="default-search-container pt-32 lg:px-28 xl:px-60">
            <a-tabs
                default-active-key="basic"
                :active-key="defaultTab"
                type="card"
                @change="onTabChange"
                :class="{ 'shadow-md rounded-md': defaultTab == 'advance' }"
            >
                <a-tab-pane key="basic" :tab="tabTitle('basic')" :forceRender="true">
                    <form-basic-search :processing="processing" :search_form="search_form" @formSubmit="handleFind" />
                </a-tab-pane>
                <a-tab-pane key="advance" :tab="tabTitle('advance')" :forceRender="true">
                    <form-advance-search
                        :processing="processing"
                        :search_form="search_form"
                        :form_mode="form_mode"
                        @formSubmit="handleFind"
                        @clear="handleClear"
                        @cancel="handleCancel"
                    />
                </a-tab-pane>
            </a-tabs>
        </div>
    </div>
</template>

<script>
import FormBasicSearch from '@/components/forms/claims/BasicSearch.vue';
import FormAdvanceSearch from '@/components/forms/claims/AdvanceSearch.vue';

import store from '@/store';

export default {
    components: {
        FormBasicSearch,
        FormAdvanceSearch,
    },
    data() {
        return {
            search_form: {
                basic_search: '',
                name: '',
                national_id: '',
                reg_no: '',
                years_from: 'all',
                chassis_no: '',
                engine_no: '',
                risk_location: '',
                all_match: 1,
            },
            form_mode: 'init',
            search_values: {},
            processing: false,
        };
    },
    computed: {
        defaultTab() {
            return this.$store.state.system.search_state;
        },
    },
    methods: {
        setTab(tab) {
            store.dispatch('system/updateSearchState', tab);
        },
        tabTitle(key) {
            switch (key) {
                case 'basic':
                    return this.$t('claims.tabs.basic');
                case 'advance':
                    return this.$t('claims.tabs.advance');
            }
        },
        onTabChange(key) {
            this.handleClear();

            switch (key) {
                case 'basic':
                    this.setTab(key);
                    break;
                case 'advance':
                    this.setTab(key);
                    break;
            }
        },
        handleFind() {
            this.search_values = this.search_form;
            let years_from = 0;

            if (this.search_values.years_from !== 'all') {
                years_from = parseInt(this.search_values.years_from) || 0;
            }

            switch (this.$store.state.system.search_state) {
                case 'basic':
                    if (this.search_values.basic_search == '') {
                        this.$notification.error({
                            message: this.$t('claims.notifications.error.basic_empty'),
                        });
                        return;
                    }
                    break;
                case 'advance':
                    if (
                        this.search_values.name == '' &&
                        this.search_values.national_id == '' &&
                        this.search_values.reg_no == '' &&
                        this.search_values.chassis_no == '' &&
                        this.search_values.engine_no == '' &&
                        this.search_values.risk_location == ''
                    ) {
                        this.$notification.error({
                            message: this.$t('claims.notifications.error.advance_empty'),
                        });
                        return;
                    }
                    break;
            }

            this.processSearchValues({
                ...this.search_values,
                years_from: years_from,
            });
        },
        handleClear() {
            this.processing = true;

            this.search_form = {
                basic_search: '',
                name: '',
                national_id: '',
                reg_no: '',
                years_from: 'all',
                chassis_no: '',
                engine_no: '',
                risk_location: '',
                all_match: 1,
            };

            this.processing = false;
        },
        handleCancel() {
            store.dispatch('system/updateSearchState', 'basic');

            this.handleClear();
        },
        processSearchValues(data) {
            this.processing = true;

            if (this.$store.getters['user/isMultiAssociation']) {
                data.association_id = this.$store.getters['user/currentAssociationId'];
            }

            this.$http
                .post('/api/claims/search', data)
                .then((response) => {
                    this.processing = false;

                    if (response.data.status == 'success') {
                        this.$router.push({
                            name: 'home-claims-search',
                            params: {
                                id: response.data.id,
                            },
                        });
                    } else {
                        this.$notification.error({
                            message: response.data.message,
                        });
                    }
                })
                .catch((error) => {
                    if (error.response.status == 403) {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.403_mod'),
                        });
                    } else {
                        this.$notification.error({
                            message: this.$t('globals.global.notifications.error.any', { code: 'CLSH01' }),
                        });
                    }
                })
                .finally(() => {
                    this.processing = false;
                });
        },
    },
};
</script>
